import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { merge, Subject } from 'rxjs';
import { debounceTime, switchMap, takeUntil } from 'rxjs/operators';
import { FilterComponent } from './filter/filter.component';
import { DeadlinesMapperService } from './services/deadlines.mapper.service';
import { DeadlinesResolverService } from './services/deadlines.resolver.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var DeadlinesComponent = /** @class */ (function () {
    function DeadlinesComponent(fuseTranslationLoaderService, fuseProgressBarService, resolverService, mapperService, router) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.fuseProgressBarService = fuseProgressBarService;
        this.resolverService = resolverService;
        this.mapperService = mapperService;
        this.router = router;
        this.autoReloadTime = 2 * 60000;
        this.subscriptions = new Subject();
        this.refreshData = new Subject();
        this.lastOpenedAtChartChanges = new Subject();
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    DeadlinesComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isLoading = true;
        this.isFiltered = true;
        this.lastOpenedAtResponse = 'lastSevenDays';
        this.lastOpenedAtSolution = 'lastSevenDays';
        merge(this.refreshData, this.filter.filtersChanged, this.lastOpenedAtChartChanges)
            .pipe(takeUntil(this.subscriptions), debounceTime(200), switchMap(function (subjectValue) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var filter, filterIsChanged, data, timelineData;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        filter = this.filter.filtersChanged.value;
                        filterIsChanged = subjectValue && JSON.stringify(subjectValue) === JSON.stringify(filter);
                        if (!(!subjectValue || filterIsChanged)) return [3 /*break*/, 2];
                        this.isFiltered = filter['isFiltered'];
                        this.showLoading();
                        return [4 /*yield*/, this.resolverService.getAverageDeadlinesAndTimeline({
                                currentWhere: filter['currentWhere'],
                                footerWhere: filter['footerWhere'],
                                responsePeriod: this.lastOpenedAtResponse,
                                solutionPeriod: this.lastOpenedAtSolution
                            })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, {
                                type: 'all',
                                data: data
                            }];
                    case 2:
                        this.isLoadingOnlyResponseChart = subjectValue['type'] === 'response';
                        this.isLoadingOnlySolutionChart = subjectValue['type'] === 'solution';
                        return [4 /*yield*/, this.resolverService.getTimeline({
                                where: filter.currentWhere,
                                timelineOption: subjectValue['value']
                            })];
                    case 3:
                        timelineData = _a.sent();
                        return [2 /*return*/, {
                                type: subjectValue['type'],
                                data: timelineData
                            }];
                }
            });
        }); }))
            .subscribe(function (result) {
            _this.hideLoading();
            _this.isLoadingOnlyResponseChart = false;
            _this.isLoadingOnlySolutionChart = false;
            if (result.type === 'all') {
                var _a = tslib_1.__read(result.data, 3), averageDeadlines = _a[0], responseTimeline = _a[1], solutionTimeline = _a[2];
                _this.data = averageDeadlines;
                _this.toResponseTimeline(responseTimeline);
                _this.toSolutionTimeline(solutionTimeline || responseTimeline);
                return;
            }
            return result.type === 'response'
                ? _this.toResponseTimeline(result.data)
                : _this.toSolutionTimeline(result.data);
        });
    };
    DeadlinesComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.next();
        this.subscriptions.complete();
        clearInterval(this.intervalID);
    };
    DeadlinesComponent.prototype.autoRefresh = function (event) {
        var _this = this;
        if (event.checked) {
            this.intervalID = setInterval(function () { return _this.refresh(); }, this.autoReloadTime);
            return;
        }
        clearInterval(this.intervalID);
    };
    DeadlinesComponent.prototype.refresh = function () {
        this.refreshData.next();
    };
    DeadlinesComponent.prototype.clearFilters = function () {
        this.filter.clearFilters();
    };
    DeadlinesComponent.prototype.goToMaintenancesPage = function (params) {
        var queryParams = this.mapperService.toMaintenancesQueryParams({
            where: this.filter.filtersChanged.value.currentWhere,
            formValue: this.filter.filterForm.value
        });
        var url = this.router.serializeUrl(this.router.createUrlTree(['manutencoes'], { queryParams: tslib_1.__assign({}, queryParams, params) }));
        window.open('/#' + url, '_blank');
    };
    DeadlinesComponent.prototype.showLoading = function () {
        this.isLoading = true;
        this.fuseProgressBarService.show();
    };
    DeadlinesComponent.prototype.hideLoading = function () {
        this.isLoading = false;
        this.fuseProgressBarService.hide();
    };
    DeadlinesComponent.prototype.toResponseTimeline = function (responseTimeline) {
        this.responseTimeline = this.mapperService.toTimeline({
            data: responseTimeline,
            type: 'firstVisit',
            timelineOption: this.lastOpenedAtResponse
        });
    };
    DeadlinesComponent.prototype.toSolutionTimeline = function (solutionTimeline) {
        this.solutionTimeline = this.mapperService.toTimeline({
            data: solutionTimeline,
            type: 'closed',
            timelineOption: this.lastOpenedAtSolution
        });
    };
    return DeadlinesComponent;
}());
export { DeadlinesComponent };
